import CircularProgress from '@mui/material/CircularProgress'
import { match } from 'ts-pattern'
import { theme } from 'styles/theme'

export enum LoaderSize {
  SMALLER,
  SMALL,
  LARGE
}

export enum LoaderVariant {
  PRIMARY,
  SECONDARY,
  TERTIARY
}

interface InjectedProps {
  variant?: LoaderVariant
  size?: LoaderSize
}

const computeSize = (loaderSize?: LoaderSize) =>
  match(loaderSize)
    .with(LoaderSize.LARGE, () => 40)
    .with(LoaderSize.SMALL, () => 20)
    .with(LoaderSize.SMALLER, () => 18)
    .otherwise(() => 20)

const computeColor = (loaderVariant?: LoaderVariant) =>
  match(loaderVariant)
    .with(LoaderVariant.SECONDARY, () => theme.palette.label.default)
    .with(LoaderVariant.TERTIARY, () => theme.palette.surface.subdued)
    .with(LoaderVariant.PRIMARY, () => theme.palette.label.default)
    .otherwise(() => theme.palette.label.default)

export const Loader = ({ variant, size }: InjectedProps) => {
  return (
    <CircularProgress
      style={{ color: computeColor(variant) }}
      size={computeSize(size)}
    />
  )
}
